<script setup lang="ts">
import AppHeader from './components/layout/AppHeader.vue';
import AppFooter from './components/layout/AppFooter.vue';
import AppToasts from './components/layout/AppToasts.vue';
import AppPlayerModerationActionOverlayAll from './components/AppPlayerModerationActionOverlayAll.vue';
import { START_LOCATION, useRouter } from 'vue-router';
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import useAppLayoutStore from '../stores/appLayoutStore.js';

const router = useRouter();
const { currentRoute } = router;

const { headerHidden } = storeToRefs(useAppLayoutStore());

const displayFooter = computed(() => currentRoute.value.meta.displayFooter ?? true);

// Fix CLS on footer. Initial navigation may be already done when app is mounted.
const routeLoaded = ref(currentRoute.value !== START_LOCATION);

router.beforeEach(() => { routeLoaded.value = false; });
router.afterEach(() => { routeLoaded.value = true; });
</script>

<template>
    <div class="app-layout bg-body-tertiary">
        <header v-if="!headerHidden" class="sticky-top">
            <AppHeader />
        </header>

        <main>
            <router-view />
        </main>

        <footer v-if="routeLoaded && displayFooter">
            <AppFooter />
        </footer>

        <AppToasts />
        <AppPlayerModerationActionOverlayAll />
    </div>
</template>

<style lang="stylus" scoped>
.app-layout
    display flex
    flex-direction column
    min-height 100vh
    min-height 100dvh

    footer
        margin-top auto
        min-height 14em
</style>
